var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');

var MiniTimer = require('MiniTimer');
var TemplateCache = require('TemplateCache');


module.exports = Backbone.View.extend({

	events: {
		'click span': 'handleClick',
	},

	initialize: function() {
		this.listenTo(this.model, "change:sortBy", this.render);
		this.lastOrderBy = null;
	},

	render: function() {
		var timer = MiniTimer("Render sortBy");
		var currentSortBy = this.model.get("sortBy");
		if ( currentSortBy == this.lastOrderBy ) return;

		this.el.innerHTML = TemplateCache.render('SortOrderTemplate', {
			active: currentSortBy,
		});
		//timer();
	},

	handleClick: function(e) {
		e.preventDefault();
		var newSortBy = $(e.currentTarget).data('orderby');

		this.$el.find('.active').removeClass('active');
		$(e.currentTarget).addClass("active");
		this.currentSortBy = newSortBy;
		this.model.setSortOrder(newSortBy);
	},

});



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/engine/views/SortOrderView.js
 **/